import { API_BASE_URL } from "../../config/constants/endpoints";
import NewsModule from "../../modules/News";
import axios from "axios";

const News = () => {
  return <NewsModule />;
};

export const getStaticProps = async () => {
  const { data } = await axios.get<NewsResponse>("/v1/news?page=1&size=10", {
    baseURL: API_BASE_URL,
  });
  return {
    props: {
      fallback: {
        [`/v1/news?page=1&size=10`]: data,
      },
    },
    revalidate: 300, // 5 minutes
  };
};

export default News;
